module.exports = __webpack_public_path__ + "img/Mark_Kay.8586e373.jpg";